import { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import {
  UiStack,
  UiText
} from '@/lib/ui';
import AttendeeList from './AttendeeList';
// import GroupHeader from '@/registration/component/Register/Layout/GroupHeader';

const GroupEmails: FC = () => {
  return (
    <RegisterLayout
      // header={<GroupHeader />}
      showShoppingCart={false}
    >
      <UiText variant={'title'}>Attendees</UiText>
      <AttendeeList />
      <UiStack height={96} />
    </RegisterLayout>
  );
};

export default GroupEmails;
